import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/business/technologies/face-ai"
    element={
      <DefaultBusinessLayout
        backgroundImage={require('../../../../assets/images/consumer/technologies/background.jpg')}
      />
    }
  >
    <Route path="business/technologies/face-ai" element={<AsyncPage />} />
  </Route>,
];
